import React, { useContext, useEffect, useState } from "react";
import Cookies from "js-cookie";
import AdminServices from "services/AdminServices";
import {
  Table,
  TableHeader,
  TableCell,
  TableFooter,
  TableContainer,
  Select,
  Input,
  Button,
  Card,
  CardBody,
  Pagination,
} from "@windmill/react-ui";
import { useTranslation } from "react-i18next";
import { FiPlus } from "react-icons/fi";

import useAsync from "hooks/useAsync";
import useToggleDrawer from "hooks/useToggleDrawer";
import UploadManyTwo from "components/common/UploadManyTwo";
import NotFound from "components/table/NotFound";
// import ProductServices from "services/ProductServices";
import PageTitle from "components/Typography/PageTitle";
import { SidebarContext } from "context/SidebarContext";
import ServiceTable from "components/service/ServiceTable";
import SelectCategory from "components/form/SelectCategory";
import MainDrawer from "components/drawer/MainDrawer";
import ServiceDrawer from "components/drawer/ServiceDrawer";
import CheckBox from "components/form/CheckBox";
import useProductFilter from "hooks/useProductFilter";
import { FiEdit, FiTrash2 } from "react-icons/fi";
import DeleteModal from "components/modal/DeleteModal";
import TableLoading from "components/preloader/TableLoading";
import SettingServices from "services/SettingServices";
import MainModal from "components/modal/MainModal";
import DepartmentServices from "services/DepartementServices";
import QuoteDrawer from "components/drawer/QuoteDrawer";
import DepartmentTable from "components/department/DepartmentTable";
import Loader from 'components/loader/Loader';
import QuoteServices from "services/QuoteServices";
import QuoteAdminTable from "components/quote/QuoteAdminTable";
import CardItemTwo from "components/dashboard/CardItemTwo";
import {
  FiLayout,
  FiTruck,
  FiBookOpen,
  FiCheck,
  FiRefreshCw,
  FiAperture,
  FiServer,
  FiTrello,
  FiGrid,
} from 'react-icons/fi';
import {

  Badge,

} from "@windmill/react-ui";


import * as XLSX from 'xlsx';

import ReactExport from "react-export-excel";
import { jsPDF } from "jspdf";
import 'jspdf-autotable';
import { useHistory } from 'react-router-dom';
const QuotesManagement = () => {
  const { id, title, subtitle, short_description, description, allId, serviceId, handleDeleteMany, handleUpdateMany } =
    useToggleDrawer();
  const { t } = useTranslation();
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [searchQuote, setSearchValue] = useState("");

  const [status, setStatus] = useState('All');

  const [stat, setStat] = useState(['Draft', 'New', 'Accepted', 'Rejected', 'Modified', 'Expired']);

  const history = useHistory();

  const handleClick = () => {
    // Replace '/your-link' with the actual path you want to navigate to
    history.push('/add-quote');
  };

  const [adminprevilegesList, setAdminprevilegesList] = useState([]);

  const [exportData, setExportData] = useState([]);
  const exportToExcel = () => {
    const dataSet = exportData.map(item => ({
      ID: '#' + t('Quote') + ' - ' + item.id,
      Date: item.quoteDate,
      User_Name: item.user.name,
      Total_HT: item.total,
      Total_TTC: item.totalAmount,
      Status: item.status,
    }));

    const ws = XLSX.utils.json_to_sheet(dataSet);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "admin_quotes");
    XLSX.writeFile(wb, "admin_quotes.xlsx");
  };

  const exportToCSV = () => {
    const csvData = exportData.map(item => [
      '#' + t('Quote') + ' - ' + item.id,
      item.quoteDate,
      item.user.name,
      item.total,
      item.totalAmount,
      item.status,

    ]);

    const csvContent = "data:text/csv;charset=utf-8," + csvData.map(e => e.join(",")).join("\n");
    const encodedUri = encodeURI(csvContent);
    const link = document.createElement("a");
    link.setAttribute("href", encodedUri);
    link.setAttribute("download", "admin_quotes.csv");
    document.body.appendChild(link);
    link.click();
  };

  const exportToPDF = () => {
    const doc = new jsPDF();
    doc.autoTable({
      head: [[t("NameTbl"), t("EmailTbl"), t("PhoneTbl"), t("StatusTbl"), t("ServiceTbl")]],
      body: exportData.map(item => [
        '#' + t('Quote') + ' - ' + item.id,
        item.quoteDate,
        item.user.name,
        item.total,
        item.totalAmount,
        item.status,

      ]),
    });
    doc.save('admin_quotes.pdf');
  };

  useEffect(() => {
    setExportData(data);
  }, [data]);



  useEffect(() => {
    async function fetchAdminprevileges() {
      try {
        const adminInfoString = Cookies.get("adminInfo");

        if (adminInfoString) {
          const adminInfo = JSON.parse(adminInfoString);

          if (adminInfo && adminInfo.id) {
            const response = await AdminServices.getStaffById(adminInfo.id);

            const adminprevileges = response.data.previleges.map(obj => { return obj.slug });
            setAdminprevilegesList(adminprevileges);
          } else {
            console.log('ID de l\'admin non trouvé dans les informations');
          }
        } else {
          console.log('Cookie adminInfo non trouvé');
        }
      } catch (error) {
        console.log('Erreur lors de la récupération des privilèges', error);
      }
    }

    fetchAdminprevileges();
  }, []);


  const {
    toggleDrawer,
    lang,
    currentPage,
    handleChangePage,
    searchText,
    category,
    setCategory,
    searchRef,
    handleSubmitForAll,
    sortedField,
    setSortedField,
    limitData,
  } = useContext(SidebarContext);

  const handleStatusInputChange = (e) => {
    const newStatusValue = e.target.value;
    setStatus(newStatusValue); // Mettez à jour l'état avec la nouvelle valeur de recherche
  };

  const fetchQuotes = async (isLoading, searchQuote) => {
    try {
      let response;
      if (status === 'All' && searchQuote == "") {
        response = await QuoteServices.getAllAdminQuote();
      }
      else if (searchQuote || status) {
        response = await QuoteServices.searchAdminQuote(searchQuote, status);
      }
      // Mettez à jour la variable data avec les données récupérées
      setData(response.data);
      console.log(response.data, "response.data");
      console.log(status, "status");
      console.log(searchQuote, "searchQuote");
    } catch (error) {
      console.error("Erreur lors de la récupération des quotes :", error);
    }
    finally {
      setIsLoading(false); // Mettre à jour l'état pour indiquer que le chargement est terminé
    }
  };

  useEffect(() => {

    fetchQuotes(isLoading, searchQuote); // Appelez la fonction fetchServices pour récupérer les projets au chargement du composant
    console.log(data, "ddd");
  }, [isLoading, searchQuote, status]); // Utilisez une dépendance vide pour que cela ne s'exécute qu'une fois au chargement du composant

  const handleSearchInputChange = (e) => {
    const newSearchValue = e.target.value;
    setSearchValue(newSearchValue); // Mettez à jour l'état avec la nouvelle valeur de recherche
  };

  // console.log("product page", data);

  // react hooks
  const [isCheckAll, setIsCheckAll] = useState(false);
  const [isCheck, setIsCheck] = useState([]);

  const handleSelectAll = () => {
    setIsCheckAll(!isCheckAll);
    setIsCheck(data?.Services.map((li) => li._id));
    if (isCheckAll) {
      setIsCheck([]);
    }
  };

  // console.log('productss',products)
  const {
    serviceData,
    filename,
    isDisabled,
    handleSelectFile,
    handleUploadMultiple,
    handleRemoveSelectFile,
  } = useProductFilter(data?.Services);
  const countQuotesByStatus = (status) => {
    return data.filter((Quote) => Quote.status === status).length;
  };
  return (
    <>
      {isLoading ? <Loader /> : null}
      <PageTitle>{t("QuotePage")}</PageTitle>
      <DeleteModal id={serviceId} ids={allId} setIsCheck={setIsCheck} title={data.title} setIsLoading={setIsLoading} />
      <MainModal id={isCheck} title={data.title} setIsLoading={setIsLoading} />

      {/* <BulkActionDrawer ids={allId} data={data} title="Services" /> */}
      <MainDrawer>
        <QuoteDrawer id={serviceId} setIsCheck={setIsCheck} setIsLoading={setIsLoading} isLoading={isLoading} isCheck={isCheck} />
      </MainDrawer>
      <Card className="min-w-0 shadow-xs overflow-hidden bg-white dark:bg-gray-800 mb-5">
        <CardBody className="">
          <form
            onSubmit={handleSubmitForAll}
            className="py-3 md:pb-0 grid gap-4 lg:gap-6 xl:gap-6 "
          >
            <div className="flex justify-start xl:w-1/2  md:w-full">
              {/* <UploadManyTwo
                title="Quotes"
                filename={filename}
                isDisabled={isDisabled}
                totalDoc={data?.totalDoc}
                handleSelectFile={handleSelectFile}
                handleUploadMultiple={handleUploadMultiple}
                handleRemoveSelectFile={handleRemoveSelectFile}
              /> */}
            </div>
         
            {/* <div className="lg:flex  md:flex xl:justify-end xl:w-1/2  md:w-full md:justify-start flex-grow-0"> */}
            <div className="grid gap-4 mb-8 lg:grid-cols-3 md:grid-cols-3 xl:grid-cols-3 xl:w-100%">
              {stat?.map((et) => (
                <CardItemTwo
                  // mode={mode}
                  // currency={currency}
                  title2={et}
                  // icon={FiBookOpen}
                  price={countQuotesByStatus(et)}
                  className="text-white dark:text-orange-100 bg-dark"
                />
              ))}
              {/* </div> */}
            </div>
          </form>

          <div className="w-full md:w-48 lg:w-48 xl:w-48">
              {/* {(adminprevilegesList?.includes("create_admin")) && ( */}

              <Button
                onClick={handleClick}
                className="w-full rounded-md h-12"
              >
                <span className="mr-2">
                  <FiPlus />
                </span>
                {t("CreateQuote")}
              </Button>
              {/* )} */}
            </div>
        </CardBody>
      </Card>

      <Card className="min-w-0 shadow-xs overflow-hidden bg-white dark:bg-gray-800 rounded-t-lg rounded-0 mb-4">
        <CardBody>
          <form
            onSubmit={handleSubmitForAll}
            className="py-3 grid gap-4 lg:gap-6 xl:gap-6 md:flex xl:flex"
          >
            <div className="flex-grow-0 md:flex-grow lg:flex-grow xl:flex-grow">
              <Input
                ref={searchRef}
                className="border h-12 text-sm focus:outline-none block w-full bg-gray-100 border-transparent focus:bg-white"
                type="search"
                name="search"
                placeholder={t("SearchQuote")}
                onChange={handleSearchInputChange}
              />
              <button
                type="submit"
                className="absolute right-0 top-0 mt-5 mr-1"
              ></button>
            </div>
            <div className="flex-grow-0 md:flex-grow lg:flex-grow xl:flex-grow">
              <Select
                onChange={handleStatusInputChange}
                className="border h-12 text-sm focus:outline-none block w-full bg-gray-100 border-transparent focus:bg-white"
              >
                <option value="All" defaultValue hidden>
                  {t("Status")}
                </option>
                <option value="All">{t("All")}</option>
                <option value="Draft" >{t("Draft")}</option>
                <option value="New">{t("New")}</option>
                <option value="Accepted">{t("Accepted")}</option>
                <option value="Rejected">{t("Rejected")}</option>
                <option value="Accepted">{t("Modified")}</option>
                <option value="Expired">{t("Expired")}</option>
              </Select>
            </div>
          </form>
        </CardBody>
      </Card>

      {serviceData?.length !== 0 ? (
        <>
          <div className="lg:flex md:flex s:flex xl:w-1/3 lg:justify-end space-x-1 xl:justify-end">

            <Button
              onClick={exportToExcel}
              className="flex-1 rounded-md h-5 text-sm"
            >
              {t("Export to Excel")}
            </Button>

            <Button
              onClick={exportToCSV}
              className="flex-1 rounded-md h-5 text-sm"
            >
              {t("Export to CSV")}
            </Button>

            <Button
              onClick={exportToPDF}
              className="flex-1 rounded-md h-5 text-sm"
            >
              {t("Export to PDF")}
            </Button>

          </div>
          <br />
          <TableContainer className="mb-8 rounded-b-lg">
            <Table>
              <TableHeader>
                <tr>

                  <TableCell>{t("ID")}</TableCell>
                  <TableCell>{t("Date")}</TableCell>
                  <TableCell>{t("NameTbl")}</TableCell>
                  <TableCell>{t("Montant HT")}</TableCell>
                  <TableCell>{t("Montant TTC")}</TableCell>
                  <TableCell>{t("Status")}</TableCell>
                  <TableCell className="text-center">{t("Details")}</TableCell>
                  <TableCell className="text-right">{t("ActionsTbl")}</TableCell>   </tr>
              </TableHeader>
              <QuoteAdminTable
                id={serviceId}
                setIsLoading={setIsLoading}
                isLoading={isLoading}
                lang={lang}
                isCheck={isCheck}
                quote={data?.quote}
                setIsCheck={setIsCheck}
                // currency={currency}
                data={data}
                searchQuote={searchQuote}
                adminprevilegesList={adminprevilegesList}

              />
            </Table>
            {/* <TableFooter>
            <Pagination
              totalResults={data?.totalDoc}
              resultsPerPage={limitData}
              onChange={handleChangePage}
              label="Quote Page Navigation"
            />
          </TableFooter> */}
          </TableContainer>
        </>
      ) : (
        <NotFound title="Quote" />
      )}
    </>
  );
};

export default QuotesManagement;
